import { Megaphone, Globe2, BookOpen, HandHeart, Users, Mic, Music } from "lucide-react";
import { activities } from "@/data/profile";

const icons = { Megaphone, Globe2, BookOpen, HandHeart, Users, Mic, Music };

export const Activities = () => (
  <section className="section" id="leadership">
    <div className="container">
      <p className="eyebrow">05 · Leadership & Activities</p>
      <h2 className="section-title">Wearing many hats, serving one purpose</h2>
      <div className="activities-grid" data-testid="activities-grid">
        {activities.map((a) => {
          const Icon = icons[a.icon];
          return (
            <article className="activity-card" key={a.id} data-testid={a.testId}>
              <div className="activity-head">
                <div className="activity-icon">
                  <Icon size={20} />
                </div>
                <span className="activity-tag">{a.tag}</span>
              </div>
              <h3 className="activity-role">{a.role}</h3>
              <p className="activity-org">{a.org}</p>
              <p className="activity-desc">{a.description}</p>
            </article>
          );
        })}
      </div>
    </div>
  </section>
);
